export default __webpack_public_path__ + "static/media/klaytn.2ba43f00.png";